export default __webpack_public_path__ + "static/media/verified-swapper.3f8c6157.svg";